module.exports = __webpack_public_path__ + "img/tarjeta_servicios_decesos_premium.2f4e276a.jpg";